<template>
  <div class="basic">
    <!-- <pre class="info-side">
      {{ JSON.stringify(formInline, null, 4) }}
    </pre> -->
    <mStep :curIndex="0" />
    <Form
      ref="formInline"
      :model="formInline"
      style="width: 100%"
      :rules="ruleInline"
      label-position="top"
      @on-validate="getvalidate"
    >
      <div class="basic-header">
        <p>参展申请</p>
        <span></span>
        <p>基本信息</p>
      </div>

      <!-- 公司名称 -->
      <div class="basic-name">
        <Row :gutter="20">
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="公司名称" prop="companyName" id="companyName">
                  <Input
                    type="text"
                    placeholder="请输入公司名称"
                    v-model="formInline.companyName"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem
                  label="英文名称"
                  prop="companyNameEn"
                  id="companyNameEn"
                >
                  <Input
                    type="text"
                    placeholder="请输入英文名称"
                    v-model="formInline.companyNameEn"
                    maxlength="200"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem
                  label="品牌名称（宣传用）"
                  prop="companyNameShort"
                  id="companyNameShort"
                >
                  <Input
                    type="text"
                    placeholder="请输入品牌名称"
                    v-model="formInline.companyNameShort"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem
                  label="统一社会信用代码"
                  prop="unifiedCode"
                  id="unifiedCode"
                >
                  <Input
                    type="text"
                    placeholder="请输入统一社会信用代码"
                    v-model="formInline.unifiedCode"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      <!-- 公司地址 -->
      <div class="basic-address">
        <Row :gutter="20">
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="公司地址" required>
                  <Row :gutter="10">
                    <Col span="8">
                      <FormItem prop="province" id="province">
                        <Select
                          v-model="formInline.province"
                          placeholder="省"
                          size="default"
                          @on-change="provinceChange"
                        >
                          <Option
                            v-for="item in provinceList"
                            :value="item.value"
                            :key="item.value"
                            >{{ item.value }}</Option
                          >
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem prop="city" id="city">
                        <Select
                          v-model="formInline.city"
                          placeholder="市"
                          size="default"
                          @on-change="cityChange"
                        >
                          <Option
                            v-for="item in cityList"
                            :value="item.value"
                            :key="item.value"
                            >{{ item.value }}</Option
                          >
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem prop="county" id="county">
                        <Select
                          v-model="formInline.county"
                          placeholder="县/区"
                          size="default"
                          @on-change="countyChange"
                        >
                          <Option
                            v-for="item in countyList"
                            :value="item.value"
                            :key="item.value"
                            >{{ item.value }}</Option
                          >
                        </Select>
                      </FormItem>
                    </Col>
                  </Row>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem prop="address" id="address" label="详细地址">
                  <Input
                    type="text"
                    placeholder="请输入详细地址"
                    v-model="formInline.address"
                    maxlength="500"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="公司座机" prop="telephone" id="telephone">
                  <Input
                    type="text"
                    placeholder="请输入公司座机"
                    v-model="formInline.telephone"
                    maxlength="50"
                  />
                  <p
                    style="
                      line-height: 1;
                      font-size: 12px;
                      color: #808080;
                      margin-top: 6px;
                    "
                  >
                    示例：+86-XX-XXXXXX
                  </p>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem prop="website" id="website" label="公司网址">
                  <Input
                    type="text"
                    placeholder="请输入公司网址"
                    v-model="formInline.website"
                    maxlength="200"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      <!-- 营业执照 -->
      <div class="basic-phone">
        <div style="margin-bottom: 20px">
          <Row :gutter="20">
            <Col span="12">
              <FormItem label="公司logo">
                <div style="display: flex; position: relative">
                  <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList2"
                    :on-success="handleSuccess2"
                    :format="['jpg', 'png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError2"
                    :on-exceeded-size="handleMaxSize2"
                    :before-upload="handleBeforeUpload2"
                    :action="uploadUrl"
                    style="margin-right: 10px"
                  >
                    <div class="upload-btn">上传公司logo</div>
                  </Upload>
                  <p
                    style="
                      position: absolute;
                      left: 0;
                      top: 34px;
                      font-size: 12px;
                      color: #808080;
                    "
                  >
                    仅支持jpg,png，不超过2M
                  </p>
                  <div class="license-img">
                    <template v-if="uploadList2 && uploadList2.length">
                      <div
                        class="license-img-list"
                        v-for="(item, index) in uploadList2"
                        :key="'upload' + index"
                      >
                        <template v-if="item.status === 'finished'">
                          {{ item.name }}
                          <span class="line"></span>
                          <span @click="handleRemoveByArr2(item)">删除</span>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="营业执照" required>
                <div style="display: flex; position: relative">
                  <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :format="['jpg', 'png', 'pdf']"
                    :max-size="5120"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    :action="uploadUrl"
                    style="margin-right: 10px"
                  >
                    <div class="upload-btn">上传营业执照</div>
                  </Upload>
                  <p
                    style="
                      position: absolute;
                      left: 0;
                      top: 34px;
                      font-size: 12px;
                      color: #808080;
                    "
                  >
                    仅支持jpg,png,pdf,不超过5M
                  </p>
                  <div class="license-img">
                    <template v-if="uploadList && uploadList.length">
                      <div
                        class="license-img-list"
                        v-for="(item, index) in uploadList"
                        :key="'upload' + index"
                      >
                        <template v-if="item.status === 'finished'">
                          {{ item.name }}
                          <span class="line"></span>
                          <span @click="handleRemoveByArr(item)">删除</span>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </FormItem>
            </Col>
          </Row>
        </div>
        <Row :gutter="20">
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="资产类型" prop="typeAsset" id="typeAsset">
                  <Select v-model="formInline.typeAsset" @on-change="getselect">
                    <Option
                      v-for="item in BusinessList"
                      :value="item.name"
                      :key="item.name"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem
                  label="企业经营类型"
                  prop="typeBusiness"
                  id="typeBusiness"
                >
                  <Select v-model="formInline.typeBusiness" v-if="isOption">
                    <Option
                      v-for="item in NatureList"
                      :value="item.name"
                      :key="item.name"
                      >{{ item.name }}</Option
                    >
                  </Select>
                  <Input
                    v-else
                    placeholder="请输入企业经营类型"
                    v-model="formInline.typeBusiness"
                    maxlength="100"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      <!-- 企业类型 -->
      <div class="basic-address">
        <Row :gutter="20">
          <Col span="12">
            <FormItem label="是否上市公司" required>
              <iSwitch
                size="large"
                @on-change="listedChange"
                style="margin-right: 14px"
                v-model="isListed"
              >
                <span slot="open">是</span>
                <span slot="close">否</span>
              </iSwitch>
              <template v-if="isListed">
                <Input
                  type="text"
                  placeholder="请输入证券交易所"
                  v-model="formInline.stockExchange"
                  style="width: 235px; margin-right: 10px"
                  maxlength="100"
                />
                <Input
                  type="text"
                  placeholder="请输入股票代码"
                  v-model="formInline.stockCode"
                  style="width: 255px"
                  maxlength="100"
                />
              </template>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="是否隶属于世界500强" required>
              <iSwitch
                size="large"
                @on-change="topNoChange"
                style="margin-right: 14px"
                v-model="isTop500"
              >
                <span slot="open">是</span>
                <span slot="close">否</span>
              </iSwitch>
              <Input
                v-if="isTop500"
                type="text"
                placeholder="请输入排名"
                v-model="formInline.topNo"
                style="width: 500px"
                maxlength="50"
              />
            </FormItem>
          </Col>
        </Row>
      </div>

      <!-- 企业规模 -->
      <div class="basic-tech" style="padding-bottom: 0">
        <Row :gutter="20">
          <Col span="12">
            <FormItem label="是否隶属于中国500强" required>
              <iSwitch
                size="large"
                @on-change="topNoChinaChange"
                style="margin-right: 14px"
                v-model="isChinaTop500"
              >
                <span slot="open">是</span>
                <span slot="close">否</span>
              </iSwitch>
              <Input
                v-if="isChinaTop500"
                type="text"
                placeholder="请输入排名"
                v-model="formInline.topChinaNo"
                style="width: 480px"
                maxlength="50"
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="是否为小微企业" required>
              <div style="display: flex">
                <iSwitch
                  size="large"
                  style="margin-right: 14px; margin-top: 5px"
                  v-model="isMicroEnterprise"
                >
                  <span slot="open">是</span>
                  <span slot="close">否</span>
                </iSwitch>
                <template v-if="isMicroEnterprise">
                  <div style="display: flex; position: relative; flex: 1">
                    <Upload
                      ref="upload"
                      :show-upload-list="false"
                      :default-file-list="defaultList3"
                      :on-success="handleSuccess3"
                      :format="['jpg', 'png']"
                      :max-size="2048"
                      :headers="formHeaders"
                      :on-format-error="handleFormatError3"
                      :on-exceeded-size="handleMaxSize3"
                      :before-upload="handleBeforeUpload3"
                      :action="uploadUrl"
                      style="margin-right: 10px"
                    >
                      <div class="upload-btn">上传小微企业证明</div>
                    </Upload>
                    <p
                      style="
                        position: absolute;
                        left: 0;
                        top: 34px;
                        font-size: 12px;
                        color: #808080;
                      "
                    >
                      仅支持jpg,png，不超过2M
                    </p>
                    <div class="license-img">
                      <template v-if="uploadList3 && uploadList3.length">
                        <div
                          class="license-img-list"
                          v-for="(item, index) in uploadList3"
                          :key="'upload' + index"
                        >
                          <template v-if="item.status === 'finished'">
                            {{ item.name }}
                            <span class="line"></span>
                            <span @click="handleRemoveByArr3(item)">删除</span>
                          </template>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </FormItem>
          </Col>
        </Row>
      </div>
      <div class="basic-tech" style="padding-bottom: 20px">
        <Row :gutter="20">
          <Col span="12">
            <FormItem label="是否为高新科技型企业" required>
              <div style="display: flex">
                <iSwitch
                  size="large"
                  style="margin-right: 14px; margin-top: 5px"
                  v-model="isHighTech"
                >
                  <span slot="open">是</span>
                  <span slot="close">否</span>
                </iSwitch>
                <template v-if="isHighTech">
                  <div style="display: flex; position: relative; flex: 1">
                    <Upload
                      ref="upload"
                      :show-upload-list="false"
                      :default-file-list="defaultList4"
                      :on-success="handleSuccess4"
                      :format="['jpg', 'png']"
                      :max-size="2048"
                      :headers="formHeaders"
                      :on-format-error="handleFormatError4"
                      :on-exceeded-size="handleMaxSize4"
                      :before-upload="handleBeforeUpload4"
                      :action="uploadUrl"
                      style="margin-right: 10px"
                    >
                      <div
                        class="upload-btn"
                        style="width: 140px; background-color: #f5f5f5"
                      >
                        上传高新科技型企业
                      </div>
                    </Upload>
                    <p
                      style="
                        position: absolute;
                        left: 0;
                        top: 34px;
                        font-size: 12px;
                        color: #808080;
                      "
                    >
                      仅支持jpg,png，不超过2M
                    </p>
                    <div class="license-img">
                      <template v-if="uploadList4 && uploadList4.length">
                        <div
                          class="license-img-list"
                          v-for="(item, index) in uploadList4"
                          :key="'upload' + index"
                          style="background-color: #f5f5f5"
                        >
                          <template v-if="item.status === 'finished'">
                            {{ item.name }}
                            <span class="line"></span>
                            <span @click="handleRemoveByArr4(item)">删除</span>
                          </template>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="是否为独角兽企业" required>
              <div style="display: flex">
                <iSwitch
                  size="large"
                  style="margin-right: 14px; margin-top: 5px"
                  v-model="formInline.isUnicorn"
                >
                  <span slot="open">是</span>
                  <span slot="close">否</span>
                </iSwitch>
              </div>
            </FormItem>
          </Col>
        </Row>
      </div>

      <div class="basic-tech" style="padding-bottom: 20px">
        <Row :gutter="20">
          <Col span="12">
            <FormItem label="是否为“小巨人”企业" required>
              <div style="display: flex">
                <iSwitch
                  size="large"
                  style="margin-right: 14px; margin-top: 5px"
                  v-model="formInline.isLittleGiantEnterprises"
                >
                  <span slot="open">是</span>
                  <span slot="close">否</span>
                </iSwitch>
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="是否为国企/央企" required>
              <div style="display: flex">
                <iSwitch
                  size="large"
                  style="margin-right: 14px; margin-top: 5px"
                  v-model="formInline.isCentralEnterprises"
                >
                  <span slot="open">是</span>
                  <span slot="close">否</span>
                </iSwitch>
              </div>
            </FormItem>
          </Col>
        </Row>
      </div>

      <!-- 展会联系人 -->
      <div class="basic-link">
        <FormItem label="展会联系人" required> </FormItem>
      </div>
      <div class="basic-links">
        <Row :gutter="20">
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="姓名" prop="linkMan" id="linkMan">
                  <Input
                    type="text"
                    placeholder="请输入姓名"
                    v-model="formInline.linkMan"
                    maxlength="50"
                  />
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="职务" prop="linkTitle" id="linkTitle">
                  <Input
                    type="text"
                    placeholder="请输入职务"
                    v-model="formInline.linkTitle"
                    maxlength="50"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="座机" prop="linkMob" id="linkMob">
                  <Input
                    type="text"
                    placeholder="请输入座机号"
                    v-model="formInline.linkMob"
                    maxlength="50"
                  />
                  <p
                    style="
                      line-height: 1;
                      font-size: 12px;
                      color: #808080;
                      margin-top: 6px;
                    "
                  >
                    示例：+86-XX-XXXXXX
                  </p>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="手机" prop="linkTelephone" id="linkTelephone">
                  <Input
                    type="text"
                    placeholder="请输入手机号"
                    v-model="formInline.linkTelephone"
                    maxlength="50"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="邮箱" prop="linkEmail" id="linkEmail">
                  <Input
                    type="text"
                    placeholder="请输入邮箱"
                    v-model="formInline.linkEmail"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="QQ" prop="linkQQ" id="linkQQ">
                  <Input
                    type="text"
                    placeholder="请输入QQ"
                    v-model="formInline.linkQQ"
                    maxlength="50"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      <!-- 市场部负责人 -->
      <div class="basic-leader">
        <FormItem label="市场部负责人" required> </FormItem>
        <Button @click="copyInfo" class="above">信息同步</Button>
      </div>
      <div class="basic-leaders">
        <Row :gutter="20">
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="姓名" prop="leader" id="leader">
                  <Input
                    type="text"
                    placeholder="请输入姓名"
                    v-model="formInline.leader"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="职务" prop="leaderTitle" id="leaderTitle">
                  <Input
                    type="text"
                    placeholder="请输入职务"
                    v-model="formInline.leaderTitle"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="座机" prop="leaderMob" id="leaderMob">
                  <Input
                    type="text"
                    placeholder="请输入座机号"
                    v-model="formInline.leaderMob"
                    maxlength="100"
                  />
                  <p
                    style="
                      line-height: 1;
                      font-size: 12px;
                      color: #808080;
                      margin-top: 6px;
                    "
                  >
                    示例：+86-XX-XXXXXX
                  </p>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem
                  label="手机"
                  prop="leaderTelephone"
                  id="leaderTelephone"
                >
                  <Input
                    type="text"
                    placeholder="请输入手机号"
                    v-model="formInline.leaderTelephone"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row :gutter="20">
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="邮箱" prop="leaderEmail" id="leaderEmail">
                  <Input
                    type="text"
                    placeholder="请输入邮箱"
                    v-model="formInline.leaderEmail"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="QQ" prop="leaderQQ" id="leaderQQ">
                  <Input
                    type="text"
                    placeholder="请输入QQ"
                    v-model="formInline.leaderQQ"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      <!-- 开票信息 -->
      <div class="basic-invoiceType">
        <p style="font-size: 18px">开票信息</p>
        <Checkbox v-model="isInvoice"><span>无开票信息</span></Checkbox>
      </div>
      <div class="basic-invoices" v-if="!isInvoice">
        <Row :gutter="20">
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem
                  label="发票抬头"
                  prop="invoiceTitle"
                  id="invoiceTitle"
                >
                  <Input
                    type="text"
                    placeholder="请输入发票抬头"
                    v-model="formInline.invoiceTitle"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="税号" prop="invoiceCode" id="invoiceCode">
                  <Input
                    type="text"
                    placeholder="请输入税号"
                    v-model="formInline.invoiceCode"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem
                  label="单位地址"
                  prop="invoiceAddress"
                  id="invoiceAddress"
                  :class="{
                    norequire: formInline.invoiceType !== '增值税专票',
                  }"
                >
                  <Input
                    type="text"
                    placeholder="请输入单位地址"
                    v-model="formInline.invoiceAddress"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem
                  label="电话号码"
                  prop="invoiceTelephone"
                  id="invoiceTelephone"
                  :class="{
                    norequire: formInline.invoiceType !== '增值税专票',
                  }"
                >
                  <Input
                    type="text"
                    placeholder="请输入电话号码"
                    v-model="formInline.invoiceTelephone"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem
                  label="开户银行"
                  prop="invoiceBank"
                  id="invoiceBank"
                  :class="{
                    norequire: formInline.invoiceType !== '增值税专票',
                  }"
                >
                  <Input
                    type="text"
                    placeholder="请输入开户银行"
                    v-model="formInline.invoiceBank"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem
                  label="银行账户"
                  prop="invoiceBankAccount"
                  id="invoiceBankAccount"
                  :class="{
                    norequire: formInline.invoiceType !== '增值税专票',
                  }"
                >
                  <Input
                    type="text"
                    placeholder="请输入银行账户"
                    v-model="formInline.invoiceBankAccount"
                    maxlength="100"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
          <Col span="12">
            <Row :gutter="10">
              <Col span="12">
                <FormItem label="开票类型" prop="invoiceType" id="invoiceType">
                  <RadioGroup v-model="formInline.invoiceType">
                    <Radio label="增值税专票">
                      <span>专票</span>
                    </Radio>
                    <Radio label="增值税普票">
                      <span>普票</span>
                    </Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      <div class="basic-btn">
        <Button
          type="primary"
          size="large"
          @click="handleSubmit('formInline')"
          :loading="loading"
          >提交并下一步</Button
        >
      </div>
    </Form>
  </div>
</template>

<script>
import mStep from "@mycomponents/m-step.vue";
import config from "@assets/config.json";
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
// import city from "@static/city.json";
import axios from "axios";
export default {
  name: "basic", // 参展申请 - 基本信息
  components: {
    mStep,
  },
  data() {
    const that = this;
    // const websiteValid = (rule, value, callback) => {
    //   if (value) {
    //     if (/(http|https):\/\/([\w.]+\/?)\S*/.test(value)) {
    //       callback();
    //     } else {
    //       callback("请输入正确的外链地址");
    //     }
    //   } else {
    //     callback();
    //   }
    // };
    // const zhValid = (rule, value, callback) => {
    //   if (/^[\u4e00-\u9fa5]+$/.test(value)) {
    //     callback();
    //   } else {
    //     callback(new Error('公司名称格式有误'));
    //   }
    // };
    // 判断英文
    const enValid = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        if (/^(?!\s*$)[A-Za-z0-9._\-\&\(\)\（）\s-]+$/.test(value)) {
          callback();
        } else {
          callback(new Error("英文名称格式有误"));
        }
      }
    };
    const invoiceAddressReg = (rule, value, callback) => {
      // 普票必填项调整：专票和普票的区分，专票所有的都必填，普票发票抬头和税号为必填，其他非必填。
      if (that.formInline.invoiceType === "增值税普票") {
        callback();
      } else {
        if (!that.formInline.invoiceAddress) {
          callback("请输入单位地址");
        } else {
          callback();
        }
      }
    };
    const invoiceCodeValid = (rule, value, callback) => {
      if (that.isInvoice) {
        // 没有发票信息
        callback();
      } else {
        if (value) {
          if (
            /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(
              value
            )
          ) {
            callback();
          } else {
            callback("发票税号格式有误");
          }
        } else {
          callback(new Error("请输入发票税号"));
        }
      }
    };
    const invoiceTelephoneReg = (rule, value, callback) => {
      // 普票必填项调整：专票和普票的区分，专票所有的都必填，普票发票抬头和税号为必填，其他非必填。
      if (that.formInline.invoiceType === "增值税普票") {
        callback();
      } else {
        if (!that.formInline.invoiceTelephone) {
          callback("请输入电话号码");
        } else {
          callback();
        }
      }
    };
    const invoiceBankReg = (rule, value, callback) => {
      // 普票必填项调整：专票和普票的区分，专票所有的都必填，普票发票抬头和税号为必填，其他非必填。
      if (that.formInline.invoiceType === "增值税普票") {
        callback();
      } else {
        if (!that.formInline.invoiceBank) {
          callback("请输入开户银行");
        } else {
          callback();
        }
      }
    };
    const invoiceBankAccountReg = (rule, value, callback) => {
      // 普票必填项调整：专票和普票的区分，专票所有的都必填，普票发票抬头和税号为必填，其他非必填。
      if (that.formInline.invoiceType === "增值税普票") {
        if (!value) {
          callback();
        } else {
          if (/^[0-9]{14,20}$/.test(value)) {
            callback();
          } else {
            callback(new Error("银行账号格式有误"));
          }
        }
      } else {
        if (!that.formInline.invoiceBankAccount) {
          callback("请输入银行账户");
        } else {
          if (/^[0-9]{14,20}$/.test(value)) {
            callback();
          } else {
            callback(new Error("银行账户格式有误"));
          }
        }
      }
    };
    return {
      provinceList: [],
      cityList: [],
      countyList: [],
      model3: "",
      sheng: [],
      shi: [],
      qu: [],
      //   city: city,
      city: [],
      speenInfo: null,
      loading: false,
      formInline: {
        companyName: "", // 公司名称
        companyNameEn: "", // 公司英文名称
        companyNameShort: "", // 公司简称(品牌名称)
        unifiedCode: "", // 统一社会信用代码
        country: "中国",
        province: "",
        city: "",
        county: "",
        address: "",
        telephone: "",
        website: "",
        typeAsset: "",
        typeBusiness: "",
        stockExchange: "", // 证件交易所
        stockCode: "", // 股票代码
        topNo: "", // 世界排名
        topChinaNo: "", // 世界排名
        isUnicorn: true, // 是否是独角兽
        isLittleGiantEnterprises: true, // 是否为“小巨人”企业
        isCentralEnterprises: true, // 是否为国企/央企
        linkMan: "",
        linkTitle: "",
        linkMob: "",
        linkQQ: "",
        linkEmail: "",
        linkTelephone: "",
        leader: "",
        leaderTitle: "",
        leaderMob: "",
        leaderQQ: "",
        leaderEmail: "",
        leaderTelephone: "",
        invoiceTitle: "",
        invoiceCode: "",
        invoiceAddress: "",
        invoiceTelephone: "",
        invoiceBank: "",
        invoiceBankAccount: "",
        invoiceType: "增值税专票",
      },
      formInline1: {
        companyName: "上海连战",
        companyNameEn: "lianzhan",
        companyNameShort: "连战",
        unifiedCode: "913505215532300332",
        country: "中国",
        province: "",
        city: "",
        county: "",
        address: "金沙江西路1555路慧创国际16号2层",
        telephone: "86-1084666617",
        website: "https://www.chinadentalshow.com/Information/?cid=132",
        typeAsset: "股份有限公司",
        typeBusiness: "生产制造",
        stockExchange: "上海证件交易所", // 证件交易所
        stockCode: "8888888888888", // 股票代码
        topNo: "444", // 世界排名
        topChinaNo: "1111", // 中国排名
        isUnicorn: true, // 是否是独角兽
        isLittleGiantEnterprises: true, // 是否为“小巨人”企业
        isCentralEnterprises: true, // 是否为国企/央企
        linkMan: "李某",
        linkTitle: "前端",
        linkMob: "86-1084666617",
        linkEmail: "2624006658@qq.com",
        linkQQ: "2624006658",
        linkTelephone: "13122959676",
        leader: "李某",
        leaderTitle: "前端",
        leaderMob: "86-1084666617",
        leaderQQ: "2624006658",
        leaderEmail: "2624006658@qq.com",
        leaderTelephone: "13122959676",
        invoiceTitle: "慕渊（上海）智能科技有限公司",
        invoiceCode: "91310118MA1JM12CX7",
        invoiceAddress: "金沙江西路1555路慧创国际16号2层",
        invoiceTelephone: "86-1084666617",
        invoiceBank: "招商银行",
        invoiceBankAccount: "6225758214779869",
        invoiceType: "增值税专票",
      },
      ruleInline: {
        // 公司信息
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "change" },
        ],
        companyNameEn: [{ validator: enValid, trigger: "change" }],
        companyNameShort: [
          { required: true, message: "请输入品牌名称", trigger: "change" },
        ],
        unifiedCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "change",
          },
          ...validator.CreditCode,
        ],
        country: [{ required: true, message: "请输入国家", trigger: "change" }],
        province: [
          { required: true, message: "请输入省份", trigger: "change" },
        ],
        city: [{ required: true, message: "请输入城市", trigger: "change" }],
        county: [{ required: true, message: "请输入区县", trigger: "change" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "change" },
        ],
        telephone: [
          { required: true, message: "请输入公司座机", trigger: "change" },
        ],
        typeAsset: [
          { required: true, message: "请选择资产类型", trigger: "change" },
        ],
        typeBusiness: [
          { required: true, message: "请选择企业经营类型", trigger: "change" },
        ],
        // 联系人
        linkMan: [{ required: true, message: "请输入姓名", trigger: "change" }],
        linkTitle: [
          { required: true, message: "请输入职务", trigger: "change" },
        ],
        linkMob: [{ required: true, message: "请输入座机", trigger: "change" }],
        linkTelephone: [
          { required: true, message: "手机号不能为空", trigger: "change" },
          ...validator.phone,
        ],
        linkEmail: validator.email,
        // 市场部
        leader: [{ required: true, message: "请输入姓名", trigger: "change" }],
        leaderTitle: [
          { required: true, message: "请输入职务", trigger: "change" },
        ],
        leaderMob: [
          { required: true, message: "请输入座机", trigger: "change" },
        ],
        leaderTelephone: [
          { required: true, message: "手机号不能为空", trigger: "change" },
          ...validator.phone,
        ],
        leaderEmail: validator.email,
        // 开票信息
        invoiceTitle: [
          { required: true, message: "请输入发票抬头", trigger: "change" },
        ],
        invoiceCode: [
          { required: true, validator: invoiceCodeValid, trigger: "blur" },
        ],
        invoiceAddress: [
          { required: true, validator: invoiceAddressReg, trigger: "blur" },
        ],
        invoiceTelephone: [
          { required: true, validator: invoiceTelephoneReg, trigger: "blur" },
        ],
        invoiceBank: [
          { required: true, validator: invoiceBankReg, trigger: "blur" },
        ],
        invoiceBankAccount: [
          { required: true, validator: invoiceBankAccountReg, trigger: "blur" },
        ],
        invoiceType: [
          { required: true, message: "请选择开票类型", trigger: "change" },
        ],
      },

      BusinessList: [],
      NatureList: [],
      AreaList: [],
      defaultList: [],
      uploadList: [],
      uploadName: "",

      defaultList2: [],
      uploadList2: [],
      uploadName2: "",

      isExport: true, // 是否是外销企业
      isListed: true, // 是否是上市公司
      isTop500: true, // 是否是世界五百强

      isChinaTop500: true, // 是否是中国五百强
      isMicroEnterprise: true, // 是否为小微企业
      isHighTech: true, // 是否为高新科技型企业
      isInvoice: false, // 有/无 开票信息

      defaultList3: [],
      uploadList3: [],
      uploadName3: "",

      defaultList4: [],
      uploadList4: [],
      uploadName4: "",

      defaultList5: [],
      uploadList5: [],
      uploadName5: "",
      basicInfo: null,
      validateList: [],
      ElepropName: "", //验证错误的prop名
      companyId: "", //公司ID
      isOption: true, //企业经营类型是否是选择框
    };
  },
  computed: {
    ...mapGetters({
      formHeaders: "commonFill/getFormHeaders",
      uploadUrl: "commonFill/getUploadUrl",
      exhibitionId: "commonFill/getExhibitionId",
      company: "commonFill/getCompany",
    }),
    userId() {
      return this.$route.query.userId;
    },
    applyCompanyId() {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId() {
      return this.$route.query.applyCompanyOrderId;
    },
    uploadUrl2() {
      return `${config.api.reqApi}/api/upload/files`;
    },
  },
  created() {
    if (!this.IsPC()) {
      this.$router.push(`/basic/mobile`);
    }
    this.init();
  },
  async mounted() {
    let listCounry = await this.getAllAddress();
    if (listCounry[0] && listCounry[0].name === "中国") {
      this.city = listCounry[0].childrens;
    }
    var city = this.city;
    for (var i in city) {
      var obj = {
        value: city[i].name,
        id: city[i].id,
      };
      this.provinceList.push(obj);
      this.shi.push(city[i].childrens);
    }
  },
  methods: {
    ...mapActions({
      getAllAddress: "getAllAddress",

      getNature: "commonFill/getNature",
      getBusinessType: "commonFill/getBusinessType",
      addApplyCompany: "commonFill/addApplyCompany",
      editApplyCompany: "commonFill/editApplyCompany",
      getAreaAll: "commonFill/getAreaAll",
      getCountryByArea: "commonFill/getCountryByArea",
      getApplyCompanyBasic: "commonFill/getApplyCompanyBasic",
      getJoinCompany: "commonFill/getJoinCompany",
      getYesLink: "commonFill/getYesLink",
      getApplyConfig: "commonFill/getApplyConfig", //获取文件
      getwordfile: "commonFill/getwordfile", //下载文档
      getCompanyBasicInfo: "commonFill/getCompanyBasicInfo", //获取公司申报的信息
    }),

    // citys
    cityJson() {
      let cityData = null;

      axios
        .get(
          "https://oss-ecrm.reed-sinopharm.com/host/data-to-blob/countries/country-province-city-county.json"
        )
        .then((response) => {
          cityData = response.data;
          // 在这里可以调用其他函数或方法来使用 cityData
          var citys = cityData[0].childrens;
          console.log(this.provinceList);
          this.city = citys;
          console.log(citys);
          for (var i in citys) {
            var obj = {
              value: citys[i].name,
              id: citys[i].id,
            };
            this.provinceList.push(obj);
            // this.cityList.push(citys[i].childrens);
          }
        })
        .catch((error) => console.error("Error fetching city data:", error));

      //         provinceList: [],
      // cityList: [],
      // countyList: [],
    },
    getvalidate(prop, status, error) {
      if (status == false) {
        console.log(prop, "prop", status, "status", error, "error");
        let opt = {
          prop: prop,
          status: status,
        };
        this.validateList.push(opt);
      }
    },
    deteleObject(obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return Number(a) - Number(b);
        });
        var str = "";
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
    async init() {
      // 申请中的
      if (this.applyCompanyId) {
        let basicInfo = await this.getApplyCompanyBasic(this.applyCompanyId);
        this.basicInfo = basicInfo;
        if (!basicInfo) return;
        console.log("basicInfo", basicInfo);
        this.formInline.companyName = basicInfo.companyName;
        this.formInline.companyNameEn = basicInfo.companyNameEn;
        this.formInline.companyNameShort = basicInfo.companyNameShort;
        this.formInline.unifiedCode = basicInfo.unifiedCode;
        this.formInline.country = basicInfo.country;
        this.formInline.province = basicInfo.province;
        this.formInline.city = basicInfo.city;
        this.formInline.county = basicInfo.county;
        this.formInline.address = basicInfo.address;
        this.formInline.website = basicInfo.website;
        this.formInline.typeAsset = basicInfo.typeAsset;
        this.formInline.typeBusiness = basicInfo.typeBusiness;
        this.provinceChange(this.formInline.province);
        this.cityChange(this.formInline.city);
        this.countyChange(this.formInline.county);

        if (basicInfo.imgBusinessLicense) {
          let imgBusinessLicense = JSON.parse(basicInfo.imgBusinessLicense);
          if (imgBusinessLicense && imgBusinessLicense.url) {
            this.uploadList.push(imgBusinessLicense);
          }
        }
        if (basicInfo.imgLogo) {
          let imgLogo = JSON.parse(basicInfo.imgLogo);
          if (imgLogo && imgLogo.url) {
            this.uploadList2.push(imgLogo);
          }
        }
        if (basicInfo.isListed === "False" || basicInfo.isListed === "false") {
          this.isListed = false;
        } else {
          this.isListed = true;
        }
        this.formInline.stockExchange = basicInfo.listedExchange;
        this.formInline.stockCode = basicInfo.listedCode;
        // 世界500强
        if (basicInfo.isTop500 === "False" || basicInfo.isTop500 === "false") {
          this.isTop500 = false;
        } else {
          this.isTop500 = true;
        }
        this.formInline.topNo = basicInfo.topNo;
        // 中国500强
        this.isChinaTop500 = basicInfo.isChinaTop500;
        this.formInline.topChinaNo = basicInfo.topChinaNo;
        this.formInline.isUnicorn = basicInfo.isUnicorn;

        this.formInline.isLittleGiantEnterprises =
          basicInfo.isLittleGiantEnterprises;
        this.formInline.isCentralEnterprises = basicInfo.isCentralEnterprises;

        if (
          basicInfo.isMicroEnterprise === "False" ||
          basicInfo.isMicroEnterprise === "false"
        ) {
          this.isMicroEnterprise = false;
        } else {
          this.isMicroEnterprise = true;
        }
        if (basicInfo.imgMicroEnterprise) {
          let imgMicroEnterprise = JSON.parse(basicInfo.imgMicroEnterprise);
          if (imgMicroEnterprise.length > 0) {
            imgMicroEnterprise.map((c) => {
              this.uploadList3.push(c);
            });
          }
        }

        if (
          basicInfo.isHighTech === "False" ||
          basicInfo.isHighTech === "false"
        ) {
          this.isHighTech = false;
        } else {
          this.isHighTech = true;
        }
        if (basicInfo.imgHighTech) {
          let imgHighTech = JSON.parse(basicInfo.imgHighTech);
          if (imgHighTech.length > 0) {
            imgHighTech.map((c) => {
              this.uploadList4.push(c);
            });
          }
        }

        this.formInline.linkMan = basicInfo.linkMan;
        this.formInline.linkTitle = basicInfo.linkTitle;
        this.formInline.linkMob = basicInfo.linkMob;
        this.formInline.linkQQ = basicInfo.linkQQ;
        this.formInline.linkEmail = basicInfo.linkEmail;
        this.formInline.telephone = basicInfo.telephone;
        this.formInline.linkTelephone = basicInfo.linkTelephone;
        this.formInline.leader = basicInfo.leader;
        this.formInline.leaderTitle = basicInfo.leaderTitle;
        this.formInline.leaderMob = basicInfo.leaderMob;
        this.formInline.leaderQQ = basicInfo.leaderQQ;
        this.formInline.leaderEmail = basicInfo.leaderEmail;
        this.formInline.leaderTelephone = basicInfo.leaderTelephone;
        if (
          basicInfo.isInvoice === "False" ||
          basicInfo.isInvoice === "false"
        ) {
          this.isInvoice = false;
        } else {
          this.isInvoice = true;
        }
        this.formInline.invoiceTitle = basicInfo.invoiceTitle;
        this.formInline.invoiceCode = basicInfo.invoiceCode;
        this.formInline.invoiceAddress = basicInfo.invoiceAddress;
        this.formInline.invoiceTelephone = basicInfo.invoiceTelephone;
        this.formInline.invoiceBank = basicInfo.invoiceBank;
        this.formInline.invoiceBankAccount = basicInfo.invoiceBankAccount;
        this.formInline.invoiceType = basicInfo.invoiceType;
      }

      // 已登录的
      if (this.userId) {
        let company = await this.getJoinCompany(this.userId);
        if (company) {
          let data = await this.getCompanyBasicInfo(company.id);
          this.companyId = company.id;
          if (!data) {
            this.formInline.companyName = company.name;
            this.formInline.companyNameEn = company.nameEn;
            this.formInline.companyNameShort = company.companyNameShort;
            this.formInline.unifiedCode = company.unifiedCode;
            this.formInline.country = company.country;
            this.formInline.province = company.province;
            this.formInline.city = company.city;
            this.formInline.county = company.county;
            this.formInline.address = company.address;
            this.formInline.website = company.website;
            this.formInline.typeAsset = company.businessType;
            this.formInline.typeBusiness = company.nature;

            this.companyId = company.id;
            this.provinceChange(this.formInline.province);
            this.cityChange(this.formInline.city);
            this.countyChange(this.formInline.county);
            if (company.businessLicenses) {
              this.uploadList.push({
                name: "营业执照",
                url: company.businessLicenses,
                status: "finished",
              });
            }
            if (company.logo) {
              this.uploadList2.push({
                name: "公司logo",
                url: company.logo,
                status: "finished",
              });
            }
          } else {
            this.formInline.companyName = data.companyName;
            this.formInline.companyNameEn = data.companyNameEn;
            this.formInline.companyNameShort = data.companyNameShort;
            this.formInline.unifiedCode = data.unifiedCode;
            this.formInline.country = data.country;
            this.formInline.province = data.province;
            this.formInline.city = data.city;
            this.formInline.county = data.county;
            this.formInline.address = data.address;
            this.formInline.website = data.website;
            this.formInline.typeAsset = data.typeAsset;
            this.formInline.typeBusiness = data.typeBusiness;
            this.provinceChange(this.formInline.province);
            this.cityChange(this.formInline.city);
            this.countyChange(this.formInline.county);
            if (data.imgBusinessLicense) {
              let imgBusinessLicense = JSON.parse(data.imgBusinessLicense);
              if (imgBusinessLicense && imgBusinessLicense.url) {
                this.uploadList.push(imgBusinessLicense);
              }
            }
            if (data.imgLogo) {
              let imgLogo = JSON.parse(data.imgLogo);
              if (imgLogo && imgLogo.url) {
                this.uploadList2.push(imgLogo);
              }
            }
            if (data.isListed === "False") {
              this.isListed = false;
            } else {
              this.isListed = true;
            }
            this.formInline.stockExchange = data.listedExchange;
            this.formInline.stockCode = data.listedCode;

            if (data.isTop500 === "False") {
              this.isTop500 = false;
            } else {
              this.isTop500 = true;
            }
            this.formInline.topChinaNo = data.topChinaNo;
            this.isChinaTop500 = data.isChinaTop500;
            if (data.isMicroEnterprise === "False") {
              this.isMicroEnterprise = false;
            } else {
              this.isMicroEnterprise = true;
            }
            if (data.imgMicroEnterprise) {
              let imgMicroEnterprise = JSON.parse(data.imgMicroEnterprise);
              if (imgMicroEnterprise.length > 0) {
                imgMicroEnterprise.map((c) => {
                  this.uploadList3.push(c);
                });
              }
            }
            if (data.isHighTech === "False") {
              this.isHighTech = false;
            } else {
              this.isHighTech = true;
            }
            if (data.imgHighTech) {
              let imgHighTech = JSON.parse(data.imgHighTech);
              if (imgHighTech.length > 0) {
                imgHighTech.map((c) => {
                  this.uploadList4.push(c);
                });
              }
            }
            this.formInline.telephone = data.telephone;
            this.formInline.linkMan = data.linkMan;
            this.formInline.linkTitle = data.linkTitle;
            this.formInline.linkEmail = data.linkEmail;
            this.formInline.linkMob = data.linkMob;
            this.formInline.linkTelephone = data.linkTelephone;
            this.formInline.leader = data.leader;
            this.formInline.leaderTitle = data.leaderTitle;
            this.formInline.leaderMob = data.leaderMob;
            this.formInline.leaderEmail = data.leaderEmail;
            this.formInline.leaderTelephone = data.leaderTelephone;
            if (data.isInvoice === "False" || data.isInvoice === "false") {
              this.isInvoice = false;
            } else {
              this.isInvoice = true;
            }
            this.formInline.invoiceTitle = data.invoiceTitle;
            this.formInline.invoiceCode = data.invoiceCode;
            this.formInline.invoiceAddress = data.invoiceAddress;
            this.formInline.invoiceTelephone = data.invoiceTelephone;
            this.formInline.invoiceBank = data.invoiceBank;
            this.formInline.invoiceBankAccount = data.invoiceBankAccount;
            this.formInline.invoiceType = data.invoiceType;
          }
        }
      }
      let area = await this.getAreaAll();
      if (area && area.length > 0) {
        area.map((c) => {
          c.value = c.name;
          c.label = c.name;
          c.loading = false;
          c.children = [];
        });
        this.AreaList = area;
      }
      let BusinessList = await this.getNature();
      if (BusinessList) {
        this.BusinessList = BusinessList;
      }

      let NatureList = await this.getBusinessType();
      if (NatureList) {
        this.NatureList = NatureList;
      }
    },
    async handleSubmit(name) {
      let valid = await this.validForm(name);
      if (!valid) {
        this.validateList = this.deteleObject(this.validateList);
        for (let i = 0; i < this.validateList.length; i++) {
          if (this.validateList[i].status == false) {
            this.ElepropName = this.validateList[i].prop;
            break;
          }
        }
        Element.prototype.documentOffsetTop = function () {
          return (
            this.offsetTop +
            (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0)
          );
        };
        let top =
          document.getElementById(this.ElepropName).documentOffsetTop() -
          window.innerHeight / 2;
        window.scrollTo(0, top);
        this.validateList = [];
        return;
      }

      // 营业执照
      let imgBusinessLicense = "";
      if (this.uploadList && this.uploadList.length) {
        imgBusinessLicense = this.uploadList[0];
      } else {
        this.$Message.error("请上传营业执照");
        return;
      }

      // logo
      let imgLogo = "";
      // if (this.uploadList2 && this.uploadList2.length) {
      //   imgLogo = this.uploadList2[0];
      // } else {
      //   this.$Message.error("请上传公司logo");
      //   return;
      // }
      this.formInline.province = this.sheng;
      this.formInline.city = this.shi;
      this.formInline.county = this.qu;

      // 是否上市
      if (this.isListed) {
        if (!this.formInline.stockExchange) {
          this.$Message.error("请输入证件交易所");
          return;
        }
        if (!this.formInline.stockCode) {
          this.$Message.error("请输入股票代码");
          return;
        }
      }

      // 是否世界500
      if (this.isTop500) {
        if (!this.formInline.topNo) {
          this.$Message.error("请输入世界排名");
          return;
        }
      }

      // 是否中国500
      if (this.isChinaTop500) {
        if (!this.formInline.topChinaNo) {
          this.$Message.error("请输入中国排名");
          return;
        }
      }

      // 小微企业证明
      let imgMicroEnterprise = "";
      if (this.isMicroEnterprise) {
        if (this.uploadList3 && this.uploadList3.length) {
          imgMicroEnterprise = this.uploadList3;
        } else {
          this.$Message.error("请上传小微企业证明");
          return;
        }
      } else {
        imgMicroEnterprise = "";
      }

      // 高新科技型企业
      let imgHighTech = "";
      if (this.isHighTech) {
        if (this.uploadList4 && this.uploadList4.length) {
          imgHighTech = this.uploadList4;
        } else {
          this.$Message.error("请上传高新科技型企业");
          return;
        }
      } else {
        imgHighTech = "";
      }

      // 有/暂不填写
      let invoiceTitle = "";
      let invoiceCode = "";
      let invoiceAddress = "";
      let invoiceTelephone = "";
      let invoiceBank = "";
      let invoiceBankAccount = "";
      let invoiceType = "";
      if (!this.isInvoice) {
        invoiceTitle = this.formInline.invoiceTitle;
        invoiceCode = this.formInline.invoiceCode;
        invoiceAddress = this.formInline.invoiceAddress;
        invoiceTelephone = this.formInline.invoiceTelephone;
        invoiceBank = this.formInline.invoiceBank;
        invoiceBankAccount = this.formInline.invoiceBankAccount;
        invoiceType = this.formInline.invoiceType;
      } else {
        invoiceTitle = "";
        invoiceCode = "";
        invoiceAddress = "";
        invoiceTelephone = "";
        invoiceBank = "";
        invoiceBankAccount = "";
        invoiceType = "";
      }

      let req = {
        companyName: this.formInline.companyName,
        companyNameEn: this.formInline.companyNameEn,
        companyId: this.companyId,
        companyNameShort: this.formInline.companyNameShort,
        unifiedCode: this.formInline.unifiedCode, // 统一社会信用代码
        country: this.formInline.country,
        province: this.formInline.province,
        city: this.formInline.city,
        county: this.formInline.county,
        address: this.formInline.address,
        telephone: this.formInline.telephone,
        website: this.formInline.website,
        typeAsset: this.formInline.typeAsset,
        typeBusiness: this.formInline.typeBusiness,
        imgBusinessLicense: JSON.stringify(imgBusinessLicense),
        imgLogo: imgLogo ? JSON.stringify(imgLogo) : "",
        isListed: this.isListed, // 是否上市
        listedExchange: this.formInline.stockExchange, // 证件交易所
        listedCode: this.formInline.stockCode, // 股票代码
        isTop500: this.isTop500, // 世界500
        topNo: this.formInline.topNo, // 世界排名
        isChinaTop500: this.isChinaTop500, // 中国500
        topChinaNo: this.formInline.topChinaNo, // 中国排名
        isUnicorn: this.formInline.isUnicorn, // 是否独角兽
        unicorn: this.formInline.isUnicorn ? "是" : "", // 是否独角兽描述
        isLittleGiantEnterprises: this.formInline.isLittleGiantEnterprises, // 是否为“小巨人”企业
        littleGiantEnterprises: this.formInline.isLittleGiantEnterprises
          ? "是"
          : "", // 是否为“小巨人”企业描述

        isCentralEnterprises: this.formInline.isCentralEnterprises, // 是否为国企/央企
        centralEnterprises: this.formInline.isCentralEnterprises ? "是" : "", // 是否为国企/央企描述

        isMicroEnterprise: this.isMicroEnterprise, // 是否为小微企业
        imgMicroEnterprise: JSON.stringify(imgMicroEnterprise),
        isHighTech: this.isHighTech, // 是否为高新科技型企业
        imgHighTech: JSON.stringify(imgHighTech),
        linkMan: this.formInline.linkMan,
        linkTitle: this.formInline.linkTitle,
        linkMob: this.formInline.linkMob,
        linkEmail: this.formInline.linkEmail,
        linkTelephone: this.formInline.linkTelephone,
        linkQQ: this.formInline.linkQQ,
        leader: this.formInline.leader,
        leaderTitle: this.formInline.leaderTitle,
        leaderMob: this.formInline.leaderMob,
        leaderEmail: this.formInline.leaderEmail,
        leaderQQ: this.formInline.leaderQQ,
        leaderTelephone: this.formInline.leaderTelephone,
        isInvoice: this.isInvoice,
        invoiceTitle: invoiceTitle,
        invoiceCode: invoiceCode,
        invoiceAddress: invoiceAddress,
        invoiceTelephone: invoiceTelephone,
        invoiceBank: invoiceBank,
        invoiceBankAccount: invoiceBankAccount,
        invoiceType: invoiceType,
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      if (this.basicInfo) {
        let opt = {
          id: this.basicInfo.id,
          setValues: {
            CompanyName: this.formInline.companyName,
            CompanyNameEn: this.formInline.companyNameEn,
            CompanyId: this.companyId,
            CompanyNameShort: this.formInline.companyNameShort,
            UnifiedCode: this.formInline.unifiedCode, // 统一社会信用代码
            Country: this.formInline.country,
            Province: this.formInline.province,
            City: this.formInline.city,
            County: this.formInline.county,
            Address: this.formInline.address,
            Telephone: this.formInline.telephone,
            Website: this.formInline.website,
            TypeAsset: this.formInline.typeAsset,
            TypeBusiness: this.formInline.typeBusiness,
            ImgBusinessLicense: JSON.stringify(imgBusinessLicense),
            ImgLogo: imgLogo ? JSON.stringify(imgLogo) : "",
            IsListed: this.isListed, // 是否上市
            ListedExchange: this.formInline.stockExchange, // 证件交易所
            ListedCode: this.formInline.stockCode, // 股票代码
            IsTop500: this.isTop500, // 是否500
            TopNo: this.formInline.topNo, //世界排名
            IsChinaTop500: this.isChinaTop500, // 是否中国500
            TopChinaNo: this.formInline.topChinaNo, // 中国排名
            IsUnicorn: this.formInline.isUnicorn, // 独角兽
            unicorn: this.formInline.isUnicorn ? "是" : "", // 是否独角兽描述
            isLittleGiantEnterprises: this.formInline.isLittleGiantEnterprises, // 是否为“小巨人”企业
            littleGiantEnterprises: this.formInline.isLittleGiantEnterprises
              ? "是"
              : "", // 是否为“小巨人”企业描述
            isCentralEnterprises: this.formInline.isCentralEnterprises, // 是否为国企/央企
            centralEnterprises: this.formInline.isCentralEnterprises
              ? "是"
              : "", // 是否为国企/央企描述
            IsMicroEnterprise: this.isMicroEnterprise, // 是否为小微企业
            ImgMicroEnterprise: JSON.stringify(imgMicroEnterprise),
            IsHighTech: this.isHighTech, // 是否为高新科技型企业
            ImgHighTech: JSON.stringify(imgHighTech),
            LinkMan: this.formInline.linkMan,
            LinkTitle: this.formInline.linkTitle,
            LinkMob: this.formInline.linkMob,
            LinkEmail: this.formInline.linkEmail,
            LinkQQ: this.formInline.linkQQ,
            LinkTelephone: this.formInline.linkTelephone,
            Leader: this.formInline.leader,
            LeaderTitle: this.formInline.leaderTitle,
            LeaderMob: this.formInline.leaderMob,
            LeaderEmail: this.formInline.leaderEmail,
            LeaderQQ: this.formInline.leaderQQ,
            LeaderTelephone: this.formInline.leaderTelephone,
            IsInvoice: this.isInvoice,
            InvoiceTitle: invoiceTitle,
            InvoiceCode: invoiceCode,
            InvoiceAddress: invoiceAddress,
            InvoiceTelephone: invoiceTelephone,
            InvoiceBank: invoiceBank,
            InvoiceBankAccount: invoiceBankAccount,
            InvoiceType: invoiceType,
          },
        };
        console.log("修改:", opt);
        let bool = await this.editApplyCompany(JSON.stringify(opt));
        this.loading = false;
        if (bool && bool.successed) {
          this.$Message.success("修改成功！");
          if (this.applyCompanyOrderId) {
            this.$router.push(
              `/fill/join/entrance?applyCompanyId=${this.applyCompanyId}&applyCompanyOrderId=${this.applyCompanyOrderId}`
            );
          } else {
            this.$router.push(
              `/fill/join/entrance?applyCompanyId=${this.applyCompanyId}`
            );
          }
        }
      } else {
        console.log("新增:", req);
        let bool = await this.addApplyCompany(JSON.stringify(req));
        this.loading = false;
        if (bool && bool.successed) {
          this.$Message.success("提交成功！");
          this.$router.push(`/fill/join/entrance?applyCompanyId=${bool.info}`);
        }
      }
    },
    async loadData(item, callback) {
      item.loading = true;
      let list = await this.getCountryByArea(item.name);
      if (list && list.length > 0) {
        list.map((c) => {
          c.label = c.name;
          c.value = c.name;
        });
        item.children = list;
      } else {
        this.$Message.warning("没有更多了");
      }
      item.loading = false;
      callback();
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          console.log(valid, "valid");
          resolve(valid);
        });
      });
    },

    listedChange(e) {
      if (!e) {
        this.formInline.stockExchange = "";
        this.formInline.stockCode = "";
      }
    },
    topNoChange(e) {
      if (!e) {
        this.formInline.topNo = "";
      }
    },
    topNoChinaChange(e) {
      if (!e) {
        this.formInline.topChinaNo = "";
      }
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList.push({
          name: this.uploadName,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName = "";
      }
    },
    handleFormatError(file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize(file) {
      debugger;
      this.uploadName = "";
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于5M的图片",
      });
    },
    handleBeforeUpload(e) {
      this.uploadName = e.name;
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`,
        });
      }
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2.push({
          name: this.uploadName2,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName2 = "";
      }
    },
    handleFormatError2(file) {
      this.uploadName2 = "";
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片",
      });
    },

    handleMaxSize2(file) {
      this.uploadName2 = "";
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的图片",
      });
    },
    handleBeforeUpload2(e) {
      this.uploadName2 = e.name;
      const limitNum = 1;
      const check = this.uploadList2.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`,
        });
      }
      return check;
    },
    handleRemoveByArr2(file) {
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
    },
    handleSuccess3(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList3.push({
          name: this.uploadName3,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName3 = "";
      }
    },
    handleFormatError3(file) {
      this.uploadName3 = "";
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize3(file) {
      this.uploadName3 = "";
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的图片",
      });
    },
    handleBeforeUpload3(e) {
      this.uploadName3 = e.name;
      const limitNum = 5;
      const check = this.uploadList3.length < limitNum;
      if (!check) {
        this.$Notice.warning({ title: `最多上传${limitNum}张图片` });
      }
      return check;
    },
    handleRemoveByArr3(file) {
      const fileList = this.uploadList3;
      this.uploadList3.splice(fileList.indexOf(file), 1);
    },
    handleSuccess4(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList4.push({
          name: this.uploadName4,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName4 = "";
      }
    },
    handleFormatError4(file) {
      this.uploadName4 = "";
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize4(file) {
      this.uploadName4 = "";
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的图片",
      });
    },
    handleBeforeUpload4(e) {
      this.uploadName4 = e.name;
      const limitNum = 5;
      const check = this.uploadList4.length < limitNum;
      if (!check) {
        this.$Notice.warning({ title: `最多上传${limitNum}张图片` });
      }
      return check;
    },
    handleRemoveByArr4(file) {
      const fileList = this.uploadList4;
      this.uploadList4.splice(fileList.indexOf(file), 1);
    },
    handleSuccess5(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList5.push({
          name: this.uploadName5,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName4 = "";
      }
    },
    handleFormatError5(file) {
      this.uploadName4 = "";
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传pdf文件",
      });
    },
    handleMaxSize5(file) {
      this.uploadName5 = "";
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的文件",
      });
    },
    handleBeforeUpload5(e) {
      this.uploadName5 = e.name;
      const limitNum = 1;
      const check = this.uploadList5.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}个文件`,
        });
      }
      return check;
    },
    handleRemoveByArr5(file) {
      const fileList = this.uploadList5;
      this.uploadList5.splice(fileList.indexOf(file), 1);
    },
    //点击省得到id找出对应的市
    provinceChange(val) {
      console.log(this.formInline.province);
      this.cityList = [];
      this.sheng = val; //为得到县储存值
      var city = this.city;
      for (var i in city) {
        if (val == city[i].name) {
          this.sheng = city[i].name;
          var shi = city[i].childrens;
          for (var j in shi) {
            var obj = {
              value: shi[j].name,
              id: shi[j].id,
            };
            this.cityList.push(obj);
          }
        }
      }
      this.validAddresss("province");
      this.validAddresss("city");
      this.validAddresss("county");
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    //改变市获取区县
    cityChange(val2) {
      this.countyList = [];
      var val = this.sheng;
      var city = this.city;
      for (var i in city) {
        var shi = city[i].childrens;
        for (var j in shi) {
          if (val2 == shi[j].name) {
            var qu = shi[j].childrens;
            this.shi = shi[j].name;
            for (var k in qu) {
              var obj = {
                value: qu[k].name,
                id: qu[k].id,
              };
              this.countyList.push(obj);
            }
          }
        }
      }
      this.validAddresss("province");
      this.validAddresss("city");
      this.validAddresss("county");
    },
    countyChange(val3) {
      this.model3 = val3;
      var city = this.city;
      for (var i in city) {
        var shi = city[i].childrens;
        for (var j in shi) {
          var qu = shi[j].childrens;
          for (var k in qu) {
            if (val3 == qu[k].name) {
              this.qu = qu[k].name;
            }
          }
        }
      }
      this.validAddresss("province");
      this.validAddresss("city");
      this.validAddresss("county");
    },

    //资产类型选择框变更
    getselect(value) {
      if (value === "其他") {
        this.isOption = false;
      } else {
        this.isOption = true;
      }
    },
    //同上按钮
    copyInfo() {
      this.formInline.leader = this.formInline.linkMan;
      this.formInline.leaderTitle = this.formInline.linkTitle;
      this.formInline.leaderEmail = this.formInline.linkEmail;
      this.formInline.leaderMob = this.formInline.linkMob;
      this.formInline.leaderQQ = this.formInline.linkQQ;
      this.formInline.leaderTelephone = this.formInline.linkTelephone;
    },

    validAddresss(name) {
      this.$refs["formInline"].validateField(name, (valid) => {
        console.log("addresss", valid);
      });
    },
  },
};
</script>

<style lang='scss'>
.norequire.ivu-form-item .ivu-form-item-label:before {
  opacity: 0;
}
</style>
<style scoped lang='scss'>
.basic {
  &-header {
    width: 100%;
    height: 64px;
    background-color: rgba(0, 161, 233, 1);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 20px 20px 10px 20px;
    background-color: #fff;
  }

  &-address {
    padding: 20px 20px 10px 20px;
    background-color: #ededed;
  }

  &-phone {
    padding: 20px 20px 10px 20px;
    background-color: #fff;
  }

  .upload-btn {
    width: 140px;
    height: 32px;
    background-color: #ededed;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
  }

  .license-img {
    display: flex;
    flex-wrap: wrap;

    &-list {
      line-height: 32px;
      padding: 0 10px;
      background-color: #fff;
      display: flex;
      border: 1px solid #dcdee2;
      border-radius: 4px;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;

      span {
        color: #1890ff;
        cursor: pointer;
      }

      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }

  &-tech {
    padding: 20px 20px 10px 20px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 20px 20px 10px 20px;
    background-color: #fff;
  }

  &-leader {
    padding: 0 30px;
    background-color: #ededed;
    position: relative;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }

    .above {
      position: absolute;
      left: 240px;
      top: 10px;
    }
  }

  &-leaders {
    padding: 20px 20px 10px 20px;
    background-color: #fff;
  }

  &-invoiceType {
    padding: 0 30px;
    background-color: #ededed;
    line-height: 48px;
    display: flex;
    justify-content: space-between;

    .ivu-checkbox-wrapper {
      margin: 0;
    }

    span {
      color: #ff0000;
      margin-left: 5px;
    }
  }

  &-invoices {
    padding: 20px 20px 10px 20px;
    background-color: #fff;
  }

  &-btn {
    margin-top: 50px;
    padding-bottom: 80px;
    text-align: center;

    button {
      width: 200px;
      height: 48px;
      background-color: rgba(0, 161, 233, 1);
      font-size: 16px;
      border-color: rgba(0, 161, 233, 1);
    }
  }

  .downLoad {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
}

.info-side {
  position: fixed;
  top: 200px;
  left: 0;
  z-index: 99999999;
  background-color: #fff;
  width: 200px;
}
</style>
